import { Component, OnInit } from '@angular/core';
import { FormControl, Validators, FormsModule, ReactiveFormsModule, FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { TherapistService } from '../../services/api/TherapistService';
import { BookingService } from '../../services/api/BookingService';

import { TherapistModel } from '../../models/api/TherapistModel';
import { BookingModel } from '../../models/api/BookingModel';
import { BookingRequest } from '../../models/api/BookingRequest'

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { NgxIntlTelInputModule, SearchCountryField, CountryISO, PhoneNumberFormat } from 'ngx-intl-tel-input';
import { SystemUserModel } from '../../models/api/SystemUserModel';
import { SystemUserService } from '../../services/api/SystemUserService';
import { AuthService } from '../../services/auth/auth.service';
import { AuthLoginModel } from '../../models/auth/AuthLoginModel';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-booking-details',
  standalone: true,
  imports: [FormsModule, DatePipe, NgxIntlTelInputModule, MatFormFieldModule, MatIconModule, MatInputModule, ReactiveFormsModule, MatSelectModule, MatButtonModule, MatProgressSpinnerModule, MatProgressBarModule, MatButtonToggleModule],
  templateUrl: './booking-details.component.html',
  styleUrl: './booking-details.component.scss'
})


export class BookingDetailsComponent implements OnInit {

  bookingForm!: FormGroup;

  public bookingId: number | undefined;
  public bookingGuid: string | undefined;
  public therapistId: number;
  public eventID: number;
  public eventName: string;
  public eventStartDate: Date;
  public eventEndDate: Date;
  public therapistName: string;
  public therapistDetail: TherapistModel | undefined;
  public bookingFormSubmit: boolean = false;
  public loading: boolean = true;
  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom];
  systemUser: SystemUserModel = new SystemUserModel;
  isTherapist: boolean = false;
  isAppUser: boolean = false;
  private userAgent: string = navigator.userAgent;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private therapistService: TherapistService,
    private fb: FormBuilder,
    private bookingService: BookingService,
    private authService: AuthService) {
    const navigation = this.router.getCurrentNavigation();
    this.therapistId = navigation?.extras?.state?.['therapistId'];
    this.therapistName = navigation?.extras?.state?.['therapistName'];
    this.eventID = navigation?.extras?.state?.['eventID'];
    this.eventName = navigation?.extras.state?.['eventName'];
    this.eventStartDate = navigation?.extras?.state?.['eventStartDate'];
    this.eventEndDate = navigation?.extras?.state?.['eventEndDate'];

  }

  ngOnInit() {


    const user = this.authService.getAuthUserRecordFromLocalStorage();
    if (user){
      this.systemUser = user.user;
      if (this.systemUser.userTypeID === 3){
        this.isTherapist = true;
      }
    }
    if (this.userAgent){
      if ((this.userAgent.includes("WHAppIOS") || this.userAgent.includes("WHAppAndroid")) && this.userAgent.includes("deviceGuid")) {
        this.isAppUser = true;
      }
    }

    this.route.params.subscribe(params => {
      if (params['guid']) {
        this.bookingGuid = params['guid'];
        if (this.bookingGuid) {
          this.bookingService.getBooking(this.bookingGuid).subscribe(data => {

            this.bookingForm.addControl('bookingID', this.fb.control(data.bookingID));
            this.therapistId = data.requestedTherapistID != null ? data.requestedTherapistID : 0;

            this.bookingForm.patchValue({
              name: data.fullName,
              mobile: data.mobileNumber,
              location: data.location,
              otherNotes: data.otherNotes,
              bookingDate: data.bookingDate,
              requestedTherapistId: data.requestedTherapistID,
              eventID: data.eventID,
              contactMethodID: data.contactMethodID,
              bookingStatusID: data.bookingStatusID,
              bookingID: data.bookingID
            })
            this.loading = false;
          });
        }

      } else {
        this.loading = false;
      }


      this.bookingForm = this.fb.group({
        name: ['', [Validators.required, Validators.minLength(1)]],
        mobile: [
          undefined,
          this.isTherapist || this.isAppUser ? [] : [Validators.required, Validators.minLength(3)]
        ],
        location: ['', [Validators.required]],
        otherNotes: ['', [Validators.required]],
        bookingDate: new Date(),
        requestedTherapistId: this.therapistId,
        eventID: this.eventID,
        contactMethodID: [1],
        bookingStatusID: 2
      });
    })
    if ((this.therapistId === null || this.therapistId === undefined) && !this.bookingGuid) {
      this.router.navigate(['/client-portal/therapist-list']);
    }

    if ((!this.eventID || this.eventID === 0) && !this.bookingGuid){
      this.router.navigate(['/client-portal/event-list']);
    }
  }


  updateBooking() {
    this.bookingForm.markAllAsTouched();
    if (this.bookingForm.valid) {
      const rawMobileValue = this.bookingForm.get('mobile')?.value;
      const booking: BookingRequest = this.bookingForm.value;

      if (rawMobileValue && typeof rawMobileValue === 'object' && 'e164Number' in rawMobileValue) {
        booking.mobile = rawMobileValue.e164Number;
      } else {
        booking.mobile = rawMobileValue || '';
      }
      if (this.bookingGuid) {


        this.bookingService.bookingUpdateMini(this.bookingGuid, booking).subscribe({
          next: (response) => {
            this.router.navigate(['/client-portal/queue/' + this.bookingGuid], { state: { bookingAddEdit: 1 } });
          },
          error: (err) => {
            console.error('Error updating booking:', err);
          }
        })
      }
    }
  }

  goBack() {
    if (this.bookingGuid) {
      this.router.navigate(['/client-portal/queue/' + this.bookingGuid], { state: { bookingAddEdit: 0 } });
    } else {
      this.router.navigate(['/client-portal/therapist-list']);
    }
  }

  createBooking() {
    this.bookingFormSubmit = true;
    this.bookingForm.markAllAsTouched();
    if (this.bookingForm.valid) {

      const rawMobileValue = this.bookingForm.get('mobile')?.value;
      const booking: BookingRequest = this.bookingForm.value;

      if (rawMobileValue && typeof rawMobileValue === 'object' && 'e164Number' in rawMobileValue) {
        booking.mobile = rawMobileValue.e164Number;
      } else {
        booking.mobile = rawMobileValue || '';
      }

      this.bookingService.bookingRequest(booking).subscribe({
        next: (response) => {

          this.bookingFormSubmit = false;


          if (this.systemUser && this.systemUser.systemUserID > 0 && this.systemUser.userTypeID === 3){
            this.router.navigate(['/therapist-portal/dashboard']);
          } else {
             this.router.navigate(['/client-portal/queue/' + response.reference], { state: { bookingAddEdit: 0 } });
             if (response && response.reference){
                localStorage.setItem('bookingGuid', response.reference);
             }
          }

        },
        error: (err) => {
          this.bookingFormSubmit = false;
          console.error('Error creating booking:', err);
        }
      });
    } else {
      this.bookingFormSubmit = false;
    }
  }
}
